import React from "react";
import "./Footer.css";
import { FormattedMessage } from "react-intl";
import { CompetencyDescriptions } from "../components/CompetencyDescriptions";

export const Footer = props => {
  const { locale, location } = props;
  const mainPage = location.pathname === '/' ? true : false;
  return (
    <footer className="Footer">
      <div className="mainContent">
        <div className="row">
          <div className="column">
            <span>
              <h2>
                <FormattedMessage id="footer.header" />
              </h2>
              <p>
                kirjaamo (at) tukes.fi
                <br /> <FormattedMessage id="footer.phonenumber" />
              </p>
              {mainPage && (
                <p>
                  <b>
                    <CompetencyDescriptions
                      locale={locale}
                      location={location}
                    />
                  </b>
                </p>
              )}
              <p>
                <b>
                  <a
                    download
                    href={`/saavutettavuusseloste_rekisterit.tukes.fi_${locale}.pdf`}
                  >
                    <FormattedMessage id="footer.accessibilityDocument" />
                  </a>
                </b>
              </p>
            </span>
          </div>
        </div>
      </div>
      <div className="bottomBar">
        <span>Copyright {(new Date().getFullYear())}</span>
      </div>
    </footer>
  );
};



// WEBPACK FOOTER //
// ./src/Layout/Footer.js